import React from "react";
import styled from "styled-components";

const Btn = styled.button`
  display: inline-grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: ${(p) => p.theme.colors.textSecondary};
  transition:
    background ${(p) => p.theme.motion.fast},
    color ${(p) => p.theme.motion.fast};
  &:hover:not(:disabled) {
    background: ${(p) => p.theme.colors.surfaceHover};
    color: ${(p) => p.theme.colors.text};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  svg {
    width: 18px;
    height: 18px;
  }
`;

type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "aria-label"> & {
  /** Доступное имя и tooltip — обязательны для иконки без текста. */
  label: string;
};

const IconButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ label, children, type = "button", ...rest }, ref) => (
    <Btn ref={ref} type={type} aria-label={label} title={label} {...rest}>
      {children}
    </Btn>
  ),
);
IconButton.displayName = "IconButton";
export default IconButton;
